import { render, staticRenderFns } from "./ControlSidebar.vue?vue&type=template&id=2f51e5be"
import script from "./ControlSidebar.vue?vue&type=script&lang=js"
export * from "./ControlSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports